import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	task__bu__emp__list: 'mw/order/task/bu/emp/list',
	task__bu__emp__search: 'mw/order/task/bu/emp/search',
	task__bu__emp__del: 'mw/order/task/bu/emp/del',
	task__bu__emp__set: 'mw/order/task/bu/emp/set',
};

export const empApi = createApi({
	reducerPath: 'mw/order/task/bu/empApi',

	endpoints: (builder) => ({
		taskBuEmpList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/order/task/bu/emp/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.task__bu__emp__list],
		}),
		taskBuEmpSearch: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/order/task/bu/emp/search?${qs.stringify(body)}`,
			}),
			providesTags: [tags.task__bu__emp__search],
		}),
		taskBuEmpDel: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/order/task/bu/emp/del',
				body,
			}),
			providesTags: [tags.task__bu__emp__del],
		}),
		taskBuEmpSet: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/order/task/bu/emp/set',
				body,
			}),
			providesTags: [tags.task__bu__emp__set],
		}),
	}),
});

export const {
	taskBuEmpList,
	taskBuEmpSearch,
	taskBuEmpDel,
	taskBuEmpSet,
} = empApi.endpoints;

export default empApi;